import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { RootState } from '../../stores/Store';

import { Sort } from '../../models/CommonModels';

import Table from '../../components/Table/Table';
import TablePagination from '../../components/TablePagination/TablePagination';

import TransactionsTableFilters from './TransactionsTableFilters';
import useTransactionsTable from './useTransactionsTable';

const initialSortState: Sort = { order: 'desc', orderBy: 'creationDate' };

function TransactionsTable() {
  const [t] = useTranslation();
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sort, setSort] = useState<Sort>(initialSortState);
  const { headers, rows, totalTransactions, isLoading, fetchTransactions, exportData } = useTransactionsTable(
    activePage,
    pageSize,
    sort,
  );
  const { filter } = useSelector((state: RootState) => state.transactionsReducer);

  /**
   * On pagination change
   * Perform a new request
   * @param page
   * @param pSize
   */
  const handlePaginationChange = (page: number, pSize: number) => {
    setActivePage(page);
    setPageSize(pSize);
  };

  /**
   * On search
   */
  const handleSearch = () => {
    setActivePage(1);
  };

  /**
   * Handle change of the table sort
   * @param s
   */
  const handleOnSort = (s: Sort) => {
    setSort(s);
  };

  /**
   * Reset the value of table sort
   */
  const resetOnSort = () => {
    setSort(initialSortState);
  };

  return (
    <Box paddingBottom="3rem">
      <TransactionsTableFilters
        fetchTransactions={fetchTransactions}
        onSearch={handleSearch}
        isLoading={isLoading}
        exportData={exportData}
        totalItems={totalTransactions}
        resetSort={resetOnSort}
      />
      <Table
        headers={headers}
        rows={rows}
        isLoading={isLoading}
        emptyStateMessage={
          filter.type === '' ? t('pages.transactions.table.selectTransactionType') : t('common.table.emptyState')
        }
        defaultOrderBy={sort.orderBy}
        onSort={handleOnSort}
      />
      <TablePagination
        activePage={activePage}
        pageSize={pageSize}
        totalItems={totalTransactions}
        handlePageChange={handlePaginationChange}
      />
    </Box>
  );
}

export default TransactionsTable;
